<h2>Hi there!</h2>

<p style="margin-top: 30vh">
    Your name is:
    <b>{params.first}</b>
    <b>{#if params.last}{params.last}{/if}</b>
</p>

<div id="sumsub-websdk-container">Hi</div>

<p>This comes from the URL, matching <code>/hello/:first/:last?</code>, where the last name is optional.</p>
<p><em>Hint:</em> Try changing the URL and add your name, e.g. <code>/hello/alex</code> or <code>/hello/jane/doe</code></p>
<p> {JSON.stringify(session)} </p>

<script>

  import {sessionData} from '../stores.js'
  import {launchWebSdk, getSumsubAccessToken} from '../sumsub.js'
  let session

  (async () => {
    const token = await getSumsubAccessToken()
    launchWebSdk(token)
  })()


// The params prop contains values matched from the URL
export let params = {}
</script>
